import Text, { TextProps } from "../Text";

const TextButton = (props: TextProps) => {
  return <Text {...props} fontSize={14} />;
};

export default TextButton;
